import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, PrecacheItemType, SinglePreCacheItem } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import GtubeMedAdmComponentsStep0Component from "./components/gtube-med-adm-components-step0/gtube-med-adm-components-step0";
import GtubeMedAdmComponentsStep0Part1 from "./components/gtube-med-adm-components-step0/gtube-med-adm-components-step0-parts/gtube-med-adm-components-step0-part1";
import GtubeMedAdmComponentsStep1Component from "./components/gtube-med-adm-components-step1/gtube-med-adm-components-step1";
import GtubeMedAdmComponentsStep1Part1 from "./components/gtube-med-adm-components-step1/gtube-med-adm-components-step1-parts/gtube-med-adm-components-step1-part1";
import GtubeMedAdmComponentsStep2Component from "./components/gtube-med-adm-components-step2/gtube-med-adm-components-step2";
import GtubeMedAdmComponentsStep2Part1 from "./components/gtube-med-adm-components-step2/gtube-med-adm-components-step2-parts/gtube-med-adm-components-step2-part1";

class Scenario9GtubeMedAdmVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 9 G-tube Med Adm';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 9 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario09/sc09-cinematic/cin-sc-9.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario09/sc09-mentor/mntr-sc-09.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario09/sc09-mentor/mntr-sc-09.mp4', // change this 
				chapterIds: [
					'scenario9-3', //question 1 correct - don't delete comment!
					'scenario9-4', //question 1 incorrect - don't delete comment!
					'scenario9-5', //question 1 other option - don't delete comment!
					'scenario9-7',//question 2 correct - don't delete comment!
					'scenario9-8', //question 2 incorrect - don't delete comment!
					'scenario9-9', //question 2 other option - don't delete comment!
					'scenario9-12', //question 3 correct - don't delete comment!
					'scenario9-13', //question 3 incorrect - don't delete comment!
					'scenario9-16', //question 4 correct - don't delete comment!
					'scenario9-14', //question 4 incorrect - don't delete comment!
					'scenario9-15', //question 4 other option - don't delete comment!
					'scenario9-19', //question 5 correct - don't delete comment!
					'scenario9-18', //question 5 incorrect - don't delete comment!
					'scenario9-1', //scenario info 
					'scenario9-20' //scenario review 
				]
			}
		];
	}
}

export const scenario9GtubeMedAdmVideoSegments = new Scenario9GtubeMedAdmVideoSegments();

class Scenario9GtubeMedAdmAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-09/mentor/jcdst-mentor-vo-scn-09-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-09/mentor/jcdst-mentor-vo-scn-09-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-09/mentor/jcdst-mentor-vo-scn-09-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-09/mentor/jcdst-mentor-vo-scn-09-19.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-09/mentor/jcdst-mentor-vo-scn-09-24.mp3'
			}
		];
	}
}

export const scenario9GtubeMedAdmAudioCaching = new Scenario9GtubeMedAdmAudioCaching();

export default class Scenario9GtubeMedAdm extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario9GtubeMedAdmVideoSegments.getItemByKey('MixedMedia'),
			scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario9GtubeMedAdm,
			title: 'G-Tube Medication Administration',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				The new graduate nurse mistakenly used normal saline instead of sterile water to mix and 
				give medications to her g tube patient at the bedside. 
				</p>
			`,
			mentorVideoUrl: scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario9GtubeMedAdmVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as GtubeMedAdmComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as GtubeMedAdmComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as GtubeMedAdmComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as GtubeMedAdmComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as GtubeMedAdmComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as GtubeMedAdmComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as GtubeMedAdmComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario9GtubeMedAdm;
    }

	private video: SingleVideoSegmentItem = scenario9GtubeMedAdmVideoSegments.getItemByKey('Scenario 9 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
			title: 'G-Tube Medication Administration',
			subtitle: 'Incident Report',
			name: 'Jamie',
			position: 'Nurse (New Graduate)',
			time: 'Day Shift',
			place: 'Progressive Care Unit (PCU)',
			desc: `The new graduate nurse mistakenly used normal saline instead of sterile water to mix and give medications 
			to her g-tube patient at the bedside.`,
			repeat: 'No',
			okButton: 'Continue'
		}
	}

	private step0Component = new GtubeMedAdmComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new GtubeMedAdmComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new GtubeMedAdmComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}